import BaseSession from 'ember-simple-auth/services/session';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';
import config from 'cpc-license-manager/config/environment';

const authConfig = config['ember-simple-auth-token'];
const TOKEN_PROPERTY_NAME = authConfig.tokenPropertyName ?? 'token';
const AUTHORIZATION_HEADER_NAME = authConfig.authorizationHeaderName ?? 'Authorization';
const AUTHORIZATION_PREFIX = authConfig.authorizationPrefix ?? 'Bearer ';

export default class JwtSession extends BaseSession {
  @service dataPreloader;

  // ember-simple-auth sets isAuthenticated to true before it has actually finished loading
  // https://github.com/simplabs/ember-simple-auth/blob/master/packages/ember-simple-auth/addon/internal-session.js#L104
  @tracked isActuallyAuthenticated = false;

  get isOidc() {
    return false;
  }

  get loginRoute() {
    return 'login';
  }

  get token() {
    return this.data?.authenticated?.[TOKEN_PROPERTY_NAME];
  }

  get formattedHeaders() {
    const headers = {};
    const token = this.token;

    if (this.isAuthenticated && isPresent(token)) {
      headers[AUTHORIZATION_HEADER_NAME] = `${AUTHORIZATION_PREFIX}${token}`;
    }

    return headers;
  }

  async handleAuthentication(routeAfterAuthentication) {
    await this.dataPreloader.loadCurrentUserAndData.perform();
    super.handleAuthentication(routeAfterAuthentication);
    this.isActuallyAuthenticated = true;
  }

  handleInvalidation(routeAfterInvalidation) {
    this.isActuallyAuthenticated = false;
    super.handleInvalidation(routeAfterInvalidation);
  }
}
